import React from "react";

interface BestTimesChipsProps {
  times: number[];
  onSelectTime: (hour: number) => void;
  selectedTime?: string;
  dayName?: string;
}

function formatHour(hour: number): string {
  // Use 24h format to match the time input
  return `${hour.toString().padStart(2, "0")}:00`;
}

function hourToTimeString(hour: number): string {
  return `${hour.toString().padStart(2, "0")}:00`;
}

export const BestTimesChips: React.FC<BestTimesChipsProps> = ({
  times,
  onSelectTime,
  selectedTime,
  dayName,
}) => {
  if (!times || times.length === 0) {
    return null;
  }

  const displayTimes = times.slice(0, 5);

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-gray-700">
        {dayName ? `Best times for ${dayName}:` : "Suggested times:"}
      </p>
      <div className="flex flex-wrap gap-2">
        {displayTimes.map((hour) => {
          const timeStr = hourToTimeString(hour);
          const isSelected = selectedTime === timeStr;

          return (
            <button
              key={hour}
              type="button"
              onClick={() => onSelectTime(hour)}
              className={`
                px-3 py-1.5 rounded-full text-sm font-medium transition-colors
                ${isSelected
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                }
              `}
            >
              {formatHour(hour)}
            </button>
          );
        })}
      </div>
    </div>
  );
};
